import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  Timer: {
    fontFamily: "sans-serif",
    textAlign: "center",
    fontSize: "18px",
  }
}));